import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

export interface TangoLedgerQuery {
  sort?: 'date' | 'amount' | 'transaction';
  direction?: 'asc' | 'desc';
  from?: string;
  to?: string;
  type?: string;
  offset?: number;
  limit?: number;
}
export interface TangoLedgerRow {
  id: string;
  occurredAt: string;
  type: string;
  category: string;
  description: string;
  reference: string | null;
  amountMinor: number | null;
  feeMinor: number | null;
  balanceEffectMinor: number | null;
  runningBalanceMinor: number | null;
  currencyCode: string;
  basis: string;
  simulated: boolean;
}
export interface TangoLedgerReport {
  account: string;
  environment: string;
  currencyCode: string;
  rows: TangoLedgerRow[];
  hasMore: boolean;
  offset: number;
  limit: number;
  summary: {
    total: number;
    creditsMinor: number;
    debitsMinor: number;
    feesMinor: number;
    unknownFeeCount: number;
    openingBalanceMinor: number | null;
    closingBalanceMinor: number | null;
    simulated: boolean;
    unresolvedCount: number;
    balanceVerified: boolean;
  };
}
@Injectable({ providedIn: 'root' })
export class TangoLedgerService {
  constructor(private restangular: ApiClient) {}
  list(query: TangoLedgerQuery): Promise<TangoLedgerReport> {
    return this.restangular.one('admin/tango/ledger').get(query).toPromise();
  }
  export(query: TangoLedgerQuery): Promise<{ filename: string; csv: string; total: number }> {
    return this.restangular.one('admin/tango/ledger/report').get(query).toPromise();
  }
}
